import { ChatBase } from './chat-base';

/**
 * TextChat model
<fields>
<field name="TextChatID" type="long" generateIfNull="true" />
<field name="ChatType" type="byte" min="0" max="6" />
<field name="ChatName" type="text" />
<field name="PhoneNumber" type="text" />
<field name="Email" type="text" />
<field name="ProfilePic" type="text" />
<field name="InternalPhoneNumber" type="text" />
<field name="OperatorID" type="long" />
<field name="DepartmentID" type="long" />
<field name="InitialDepartmentID" type="long" />
<field name="LastAssignedByOperatorID" type="long" />
<field name="LanguageCode" type="text" size="2" default="en" changeCase="lower" />
<field name="ResponseMessageCount" type="integer" default="0" />
<field name="TotalResponseTime" type="integer" default="0" />
<field name="LastMessagePersonType" type="byte" min="0" max="1" default="0" />
<field name="LastMessageSent" type="datetime" />
<field name="RelatedToItemID" type="long" />
<field name="AccountID" type="long" useAccountIDIfNull="true" />
<field name="Created" type="created" allowsUpdates="false" />
<field name="Answered" type="datetime" />
<field name="Ended" type="datetime" />
<field name="Unended" type="datetime" />
<field name="Closed" type="datetime" />
<field name="Updated" type="updated" />
<field name="Deleted" type="datetime" />
<field name="FolderID" type="long" />
<field name="DueDate" type="datetime" />
<field name="Started" type="datetime" />
<field name="UnrespondedMessageCount" type="integer" default="0" />
<field name="Flagged" type="datetime" />
<field name="VisitorMessageCount" type="integer" default="0" />
<field name="OperatorMessageCount" type="integer" default="0" />
<field name="UserCategoryID" type="long" />
<field name="UserStatusID" type="long" />
<field name="CustomField1ID" type="long" />
<field name="CustomField2ID" type="long" />
<field name="TextUserID" type="long" />
<field name="TextReceiverID" type="long" />
<field name="RelatedToItemType" type="byte" default="0" />
<field name="CountryCode" type="text" />
<field name="RegionCode" type="text" />
<field name="AreaCode" type="text" />
<field name="City" type="text" />
<field name="InitialQuestion" type="text" />
<field name="ChatStatusType" type="byte" default="0" />
<field name="LastAssignedAnswered" type="datetime" />
<field name="ACDReassignCount" type="integer" default="0" />
<field name="TotalReassignCount" type="integer" default="0" />
<field name="MaxQueuePosition" type="integer" default="0" />
<field name="LastVisitorMessageSent" type="datetime" />
<field name="EndedBy" type="long" />
<field name="EndedReasonType" type="byte" />
<field name="ExternalCrmItemID" type="text" />
<field name="ExternalCrmListID" type="text" />
<field name="ExternalCrmType" type="byte" />
<field name="VisitCreated" type="datetime" />
<field name="BlockedBy" type="long" />
<field name="DeletedBy" type="long" />
<field name="ClientType" type="byte" />
<field name="Priority" type="byte" />
<field name="Load" type="double" />
<field name="AutoResponderState" type="text" />
<field name="LastACDStarted" type="datetime" />
</fields>
 *
 * @param textChat
 * @constructor
 */
class TextChat extends ChatBase {
  public TextChatID?: number;
  public PersonType?: number;
  public PersonID?: number;
  public Name?: string;
  public AccountID?: number;
  public TextUserID?: string;

  static comparator(textChat1, textChat2) {
    return textChat1.TextChatID === textChat2.TextChatID;
  }
}

function factory() {
  return TextChat;
}

export { TextChat, factory };
